/* RESPONSIBLE TEAM: team-inbox-management */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'ember-intl/services/intl';
import type ConversationSla from 'embercom/models/inbox/conversation-sla';

export default class SlaController extends Controller {
  @service declare router: RouterService;
  @service declare intercomEventService: $TSFixMe;
  @service declare appService: AppService;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;

  queryParams = [];
  declare model: { officeHoursSchedules: any; slas: any };

  @tracked showCreateDrawer = false;

  get canUseCreateDrawer() {
    return this.appService.app.canUseFeature('sla-settings-create-drawer');
  }

  @action
  showSLAHelpArticle() {
    window.Intercom('showArticle', 6546152); // https://www.intercom.com/help/en/articles/6546152-set-slas-for-conversations-and-tickets
  }

  @action
  openCreateDrawer(fromBanner = false) {
    this.showCreateDrawer = true;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'new_sla_button',
      place: 'settings.sla',
      section: fromBanner ? 'discovery_banner.sla' : 'header.sla',
    });
  }

  @action
  closeCreateDrawer() {
    this.showCreateDrawer = false;
  }

  @action
  onSlaCreated(_sla: ConversationSla) {
    this.showCreateDrawer = false;
    this.notificationsService.notifyConfirmation(this.intl.t('settings.data.sla.create-success'));
  }

  @action
  navigateToWorkflows(fromBanner = false) {
    this.router.transitionTo('apps.app.automation.workflows-overview');
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'new_sla_button',
      place: 'settings.sla',
      section: fromBanner ? 'discovery_banner.sla' : 'header.sla',
    });
  }
}
